import React from "react";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import AppConfigService from "../../../../service/app_config/AppConfigService";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import { TextBlock } from "../../../../widget/common/ui/Text";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import Div from "../../../../widget/common/ui/Div";
import Center from "../../../../widget/common/ui/Center";
import { AlertConfirm } from "../../../../widget/common/ui/Alerts";
import SessionStorage from "../../../../service/storage/SessionStorage";
import StorageKeys from "../../../../const/StorageKeys";
import { navigate } from "../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../routes/routes";

type SignupCompanyLogoProps = {
  title: string;
  logoSize?: number;
};

export const SignupCompanyLogo: React.FC<SignupCompanyLogoProps> = ({
  title = "",
}) => {
  const type: number = ResponsiveDeviceType();

  const handleClickLogo = () => {
    AlertConfirm({
      title: "wish_to_leave",
      onConfirm: async () => {
        SessionStorage.deleteValue(StorageKeys.signup_verification_detail);
        SessionStorage.deleteValue(
          StorageKeys.signup_third_party_connect_detail
        );
        SessionStorage.deleteValue(StorageKeys.account_id);
        navigate(appRoutes.routeNameLogin);
      },
    });
  };

  return (
    <Div className="pt-3">
      <Center>
        <div role="button" onClick={handleClickLogo}>
          <LogoRound
            url={AppConfigService.get("company_logo")}
            name={AppConfigService.get("company_name")}
            className="login-logo"
            size={type === 1 ? 100 : 150}
          />
        </div>
      </Center>
      <SpacingHeight value={type === 3 ? 50 : 30} />
      <TextBlock
        center={true}
        fontSize="16_17"
        fontName="bold"
        textColor="theme-label"
      >
        {AppTranslation.text(title)}
      </TextBlock>
      <SpacingHeight value={type === 1 ? 35 : type === 2 ? 48 : 45} />
    </Div>
  );
};
